import {Component, Output, Input, ElementRef, EventEmitter, Renderer2,
    OnChanges, OnInit, AfterViewInit, AfterContentChecked, Inject} from '@angular/core';
import {AbsTablesComponent} from './abs-tables.component';

@Component({
    selector: '[abs-table-header]',
    template: `<span *ngIf="sortable" [attr.aria-sort]="(sortPattern !== null && sortPattern) || 'none'" (click)="(sortable !== false) && sort(sortableContent.value);" >
    <a href="javascript:void(0)" role="button">
        <span>
            {{sortableContent.text}}
        </span>
        <i [attr.aria-hidden]="isMobile? 'false': 'true'" role="img"  [ngClass]="{'icon-arrows-sort-ascending': sortPattern === 'ascending','active':(sortPattern === 'ascending'||sortPattern === 'descending'), 'icon-arrows-sort-descending': sortPattern === 'descending'}" [attr.aria-live]="polite"></i>
    </a>
</span>
<span *ngIf="!sortable"  [attr.aria-sort]="none" ><ng-content></ng-content></span>`
})

export class AbsTableHeaderComponent implements OnInit, OnChanges, AfterViewInit,AfterContentChecked {
    @Input('priority') priority: string;
    @Input('index') index;
    @Input('sortableContent') sortableContent: any;
    @Input('sortable') sortable: any;
    @Output()
    change: EventEmitter<any> = new EventEmitter<any>();
     defaultSortPattern: any = false;
     sortPattern: any;
     reverse: any;
     headerName: any;
     headerId: any;
     columnIndex: any;
     hideArr = [];

    constructor(
        @Inject(ElementRef) private element: ElementRef,
        @Inject(Renderer2) private renderer: Renderer2,
        @Inject(AbsTablesComponent) private absTable: AbsTablesComponent
    ) { }
    ngOnInit() {
        this.sortPattern ='ascending';
        this.reverse = this.defaultSortPattern;
        const priority = parseInt(this.priority, 10);
        let element = this.element.nativeElement;
        this.columnIndex = this.absTable.setIndex(element, priority);

        this.renderer.listen(window, 'resize', () => {
            let headerArr = this.element.nativeElement.parentElement.querySelectorAll('[abs-table-header]');
            for (let i = 10; i >= 10 && i < (headerArr.length + 10); i++) {
                const priority1 = parseInt(this.priority, 10);
                const element = this.element.nativeElement;
                this.columnIndex = this.absTable.setIndex(element, priority1);
                break;
            }
            let flag = true;
            setTimeout(() => {
                if (flag === true && headerArr[0] === this.element.nativeElement) {
                    this.absTable.resizeListener();
                    flag = false;
                }
            });
        });


    }
     isHidden() {
        this.hideArr = this.absTable.hiddenColumn;
        return (this.absTable.hiddenColumn.indexOf(this.columnIndex) > -1);
    }
     hidingFn() {
        let headerArr = this.element.nativeElement.parentElement.querySelectorAll('[abs-table-header]');
        if (headerArr[0] === this.element.nativeElement) {
            for (let i = 0; i < headerArr.length; i++) {
                const sw = this.absTable.hiddenColumn.indexOf(i) > -1;
                if(sw){
                    this.renderer.setAttribute(headerArr[i],"hidden","true");
                }
                else{
                    this.renderer.removeAttribute(headerArr[i],"hidden");
                }
            }
        }
    }
    ngAfterContentChecked() {
        this.hidingFn();
    }
    ngOnChanges(value) {
        return this.element.nativeElement.innerHTML;
    }
    sort(header) {
        this.reverse = !this.reverse;
        this.sortPattern = this.reverse ? 'descending' : 'ascending';
        this.absTable.sortTable(header);
    }
     resetSortPattern() {
        this.reverse = this.defaultSortPattern;
    }
    ngAfterViewInit() {
        this.headerName = this.element.nativeElement.querySelector('[role="columnheader"]');
        this.headerId = this.element.nativeElement.getAttribute('id');
    }
}

